module.exports = __webpack_public_path__ + "static/media/id.da9fcc06.svg";